<div class="top">
  <div class="heading">
      <span class="fw-bold" style="font-size: 18px; text-transform: uppercase;">{{dialogData?.firstName + " " + this.dialogData?.lastName}}</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
      close
  </i>
</div>


<div class="form-wrapper">

  <form [formGroup]="form">

    <div class="form-section">
      <h5 class="form-section-heading mb-3">DECEASED DETAILS:</h5>
      <div class="body">
        <div class=" row g-3">
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">SURNAME</label>
              <input type="text" placeholder="Enter surname" class="form-control mt-0" formControlName="surname"
                maxlength="60" />
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">FIRST NAME</label>
              <input type="text" placeholder="Enter first name" class="form-control mt-0" formControlName="firstName"
                maxlength="60" />
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">MIDDLE NAME</label>
              <input type="text" placeholder="Enter middle name" class="form-control mt-0" formControlName="middleName"
                maxlength="60" />
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">GENDER</label>
              <select class="form-control small-option-font" formControlName="gender">
                <option value="">-- Select--</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
            </select>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">ADDRESS</label>
              <input type="text" placeholder="Enter address" class="form-control mt-0"
                formControlName="address" maxlength="100" />

            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">DATE OF DEATH</label>
              <input type="date" class="form-control mt-0" formControlName="dod" />

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">TYPE OF DEATH</label>
              <select class="form-control small-option-font" formControlName="typeOfDeath">
                <option value="">-- Select--</option>
                <option value="Accident">Accident</option>
                <option value="Natural">Natural</option>
                <option value="Sickness">Sickness</option>
            </select>

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">PLACE OF DEATH</label>
              <input type="text" placeholder="Enter Address" class="form-control mt-0" formControlName="placeOfDeath"
                maxlength="150" />

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0">TIME OF DEATH</label>
              <input type="time" class="form-control mt-0" formControlName="timeOfDeath"/>

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">Proof of Death</label>
              <div class="mt-2">
                <a [href]="form.get('proofOfDeath').value" target="_blank">
                  <img
                    [src]="form.get('proofOfDeath').value"
                    alt="Proof of Death"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">Means of ID.</label>
              <div class="mt-2">
                <a [href]="form.get('deceasedMeansOfId').value" target="_blank">
                  <img
                    [src]="form.get('deceasedMeansOfId').value"
                    alt="Proof of Death"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <div class="form-section">
      <h5 class="form-section-heading mb-3">DECEASED RELATION INFORMATION:</h5>
      <div class="body">
        <div class=" row g-3">
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">ASIN</label>
              <input type="text" placeholder="Enter ASIN" class="form-control mt-0" formControlName="relationAsin"
                maxlength="60" />

            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">SURNAME</label>
              <input type="text" placeholder="Enter Surname" class="form-control mt-0" formControlName="relationSurname"
                maxlength="60" />

            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">FIRST NAME</label>
              <input type="text" placeholder="Enter first name" class="form-control mt-0" formControlName="relationFirstName"
                maxlength="60" />

            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">MIDDLE NAME</label>
              <input type="text" placeholder="Enter middle name" class="form-control mt-0" formControlName="relationMiddleName"
                maxlength="60" />

            </div>
          </div>

          <div class="col-sm-6 col-md-4 ">
            <div class="field">
              <label class="mb-0 required">PHONE NUMBER</label>
              <input type="text" placeholder="e.g. 09087763552" class="form-control mt-0"
                formControlName="relationPhoneNumber" maxlength="17" />

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">ADDRESS</label>
              <input type="text" placeholder="Enter address" class="form-control mt-0"
                formControlName="relationAddress" maxlength="17" />

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">RELATIONSHIP WITH DECEASED</label>
              <input type="text" placeholder="Enter address" class="form-control mt-0"
                formControlName="relationship" maxlength="17" />

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">Means of ID.</label>
              <div class="mt-2">
                <a [href]="form.get('relationMeansOfId').value" target="_blank">
                  <img
                    [src]="form.get('relationMeansOfId').value"
                    alt="Proof of Death"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>

  </form>


</div>

<div class="modal-actions-wrapper"
    *ngIf="hasAccess(['CAN_APPROVE_DEATH_REGISTRATION']) && dialogData?.approvalStatus == 'PENDING' ">
    <button type="submit" class="btn flex-btn btn-danger w-100" (click)="queryApplication()">
        <span>DECLINE</span>
        <span class="spinner-light" *ngIf="isQueryingApplication"></span>
    </button>

    <button type="submit" class="btn flex-btn btn-success w-100" (click)="approveApplication()">
        <span>APPROVE</span>
        <span class="spinner-light" *ngIf="isApprovingApplication"></span>
    </button>
</div>